import { render, staticRenderFns } from "./expertExtractionList.vue?vue&type=template&id=647fee04&scoped=true"
import script from "./expertExtractionList.vue?vue&type=script&lang=js"
export * from "./expertExtractionList.vue?vue&type=script&lang=js"
import style0 from "./expertExtractionList.vue?vue&type=style&index=0&id=647fee04&prod&lang=less&scoped=true"
import style1 from "./expertExtractionList.vue?vue&type=style&index=1&id=647fee04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647fee04",
  null
  
)

export default component.exports